var sort = require('../array/virtual/sort');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.sort;
  return it === ArrayPrototype || it instanceof Array && own === ArrayPrototype.sort ? sort : own;
};